module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_salada.ca6359fe.png";